<template>
  <div class="subtitle"></div>
</template>

<script>
import KlickartPage from '@/services/request/klickartPage';
import i18n from '@/i18n';

export default {
  data() {
    return {
      i18n,
    };
  },
  mounted() {
    const klickartPage = new KlickartPage();
    const subtitle = this.$el;

    klickartPage.page(`${this.$route.params.pageIdentifier}`)
    .then((response) => {
      let html = response.data;
      html = html.replace(/http:/g, 'https:');
      subtitle.innerHTML = html;
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/screens/Layout/components/subtitle/KlickartHeaderSubtitle.vue